"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateVerificationSessionResponseDataStatusEnum = void 0;
exports.instanceOfCreateVerificationSessionResponseData = instanceOfCreateVerificationSessionResponseData;
exports.CreateVerificationSessionResponseDataFromJSON = CreateVerificationSessionResponseDataFromJSON;
exports.CreateVerificationSessionResponseDataFromJSONTyped = CreateVerificationSessionResponseDataFromJSONTyped;
exports.CreateVerificationSessionResponseDataToJSON = CreateVerificationSessionResponseDataToJSON;
exports.CreateVerificationSessionResponseDataToJSONTyped = CreateVerificationSessionResponseDataToJSONTyped;
/**
 * @export
 */
exports.CreateVerificationSessionResponseDataStatusEnum = {
    Processing: 'processing',
    Verified: 'verified',
    RequiresInput: 'requires_input',
    Canceled: 'canceled',
    Expired: 'expired'
};
/**
 * Check if a given object implements the CreateVerificationSessionResponseData interface.
 */
function instanceOfCreateVerificationSessionResponseData(value) {
    if (!('sessionId' in value) || value['sessionId'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('verificationId' in value) || value['verificationId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function CreateVerificationSessionResponseDataFromJSON(json) {
    return CreateVerificationSessionResponseDataFromJSONTyped(json, false);
}
function CreateVerificationSessionResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sessionId': json['sessionId'],
        'url': json['url'],
        'verificationId': json['verificationId'],
        'status': json['status'],
        'ephemeralKeySecret': json['ephemeralKeySecret'] == null ? undefined : json['ephemeralKeySecret'],
    };
}
function CreateVerificationSessionResponseDataToJSON(json) {
    return CreateVerificationSessionResponseDataToJSONTyped(json, false);
}
function CreateVerificationSessionResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sessionId': value['sessionId'],
        'url': value['url'],
        'verificationId': value['verificationId'],
        'status': value['status'],
        'ephemeralKeySecret': value['ephemeralKeySecret'],
    };
}
